import { createAction } from 'redux-actions';

export const callApiGetInformationXPAND = createAction('CALL_API_GET_INFORMATION_XPAND_VIEWER');
export const callApiGetInformationXPANDReceived = createAction('CALL_API_GET_INFORMATION_XPAND_RECEIVED');
export const callApiGetInformationXPANDReceivedFailure = createAction('CALL_API_GET_INFORMATION_XPAND_RECEIVED_FAILURE');
export const clearGetInfomationData = createAction('CLEAR_GET_INFOMATION_DATA');

export const callApiCreateViewer = createAction('CALL_API_CREATE_VIEWER');
export const callApiCreateViewerReceived = createAction('CALL_API_GET_CREATE_VIEWER_RECEIVED');
export const callApiCreateViewerReceivedFailure = createAction('CALL_API_GET_CREATE_VIEWER_RECEIVED_FAILURE');
export const clearDataCreateViewer = createAction('CLEAR_DATA_CREATE_VIEWER');
